export default {
  // ProviderVoicesEditor
  'pages.providerVoicesEditor.msg.deleted': 'Voice deleted',
  'pages.providerVoicesEditor.msg.nameRequired': 'name is required',
  'pages.providerVoicesEditor.msg.displayNameRequired': 'display_name is required',
  'pages.providerVoicesEditor.msg.saveSuccess': 'Saved successfully',
  'pages.providerVoicesEditor.msg.savedList': 'Voice list saved',
  'pages.providerVoicesEditor.msg.pastePrompt': 'Please paste a JSON or YAML array',
  'pages.providerVoicesEditor.msg.parseFailed': 'Parsing failed, please check the JSON/YAML format',
  'pages.providerVoicesEditor.msg.mustBeArray': 'The import format must be an array (JSON or YAML)',
  'pages.providerVoicesEditor.msg.importSuccess': 'Successfully imported {n} voices',
  'pages.providerVoicesEditor.msg.cleared': 'Voice list cleared',
  'pages.providerVoicesEditor.drawer.title': 'Manage voices',
  'pages.providerVoicesEditor.btn.importJson': 'Import JSON/YAML',
  'pages.providerVoicesEditor.btn.clear': 'Clear',
  'pages.providerVoicesEditor.btn.saveClose': 'Save and close',
  'pages.providerVoicesEditor.btn.add': 'Add voice',
  'pages.providerVoicesEditor.btn.pasteImport': 'Paste to import (JSON/YAML)',
  'pages.providerVoicesEditor.btn.preview': 'Preview',
  'pages.providerVoicesEditor.btn.edit': 'Edit',
  'pages.providerVoicesEditor.btn.delete': 'Delete',
  'pages.providerVoicesEditor.list.language': 'Language',
  'pages.providerVoicesEditor.list.mandarin': 'Mandarin',
  'pages.providerVoicesEditor.modal.editTitle': 'Edit voice',
  'pages.providerVoicesEditor.modal.addTitle': 'Add voice',
  'pages.providerVoicesEditor.label.voiceId': 'Voice ID *',
  'pages.providerVoicesEditor.label.displayName': 'Display name *',
  'pages.providerVoicesEditor.label.sex': 'Gender',
  'pages.providerVoicesEditor.label.description': 'Description',
  'pages.providerVoicesEditor.label.audioUrl': 'Preview audio URL',
  'pages.providerVoicesEditor.label.language': 'Language',
  'pages.providerVoicesEditor.placeholder.language': 'e.g. Mandarin, English, Cantonese, Japanese',
  'pages.providerVoicesEditor.import.title': 'Import JSON/YAML array',
  'pages.providerVoicesEditor.import.appendOk': 'Append import',
  'pages.providerVoicesEditor.import.replaceAll': 'Replace all and import',
  'pages.providerVoicesEditor.import.loadSample': 'Load sample',
  'pages.providerVoicesEditor.import.placeholder': 'Please paste a JSON or YAML array. Use the "Load sample" button to insert a format example',

  // LogViewer
  'pages.admin.ops.logViewer.fetchFailed': 'Failed to fetch log list',
  'pages.admin.ops.logViewer.downloadFailed': 'Download failed',
  'pages.admin.ops.logViewer.previewFailed': 'Preview failed',
  'pages.admin.ops.logViewer.columnName': 'File name',
  'pages.admin.ops.logViewer.columnSize': 'Size (bytes)',
  'pages.admin.ops.logViewer.columnMtime': 'Modified time',
  'pages.admin.ops.logViewer.columnAction': 'Actions',
  'pages.admin.ops.logViewer.download': 'Download',
  'pages.admin.ops.logViewer.refresh': 'Refresh',

  // OssMediaUpload
  'pages.ossMediaUpload.sizeExceed': 'File size cannot exceed {n}MB',
  'pages.ossMediaUpload.formatOnly': 'Only these formats are supported: {formats}',
  'pages.ossMediaUpload.selectImage': 'Please select an image file',
  'pages.ossMediaUpload.selectVideo': 'Please select a video file',
  'pages.ossMediaUpload.uploadSuccess': 'Upload successful',
  'pages.ossMediaUpload.uploadFailed': 'Upload failed',
  'pages.ossMediaUpload.dragText': 'Click or drag a file here to upload',
  'pages.ossMediaUpload.dragHint': 'It will be saved to OSS, please save when submitting the form',
  'pages.ossMediaUpload.uploadedFile': 'Uploaded file',

  // LLMProvider
  'pages.admin.providerModal.coze.token.placeholder': 'Enter Coze Token',
  'pages.admin.providerModal.coze.botid.placeholder': 'Enter Coze Bot ID',
  'pages.admin.providerModal.coze.userid.placeholder': 'Optional: Coze User ID',
  'pages.admin.providerModal.coze.botid.required': 'Please enter Bot ID',
  'pages.admin.providerModal.commercialLicenseOnly': 'Only allow commercially licensed devices (requires a commercial agent)',

  // VLLLMProvider
  'pages.admin.providerModal.security.maxFileSize': 'Max file size (bytes)',
  'pages.admin.providerModal.security.maxPixels': 'Max pixels',
  'pages.admin.providerModal.security.maxWidth': 'Max width',
  'pages.admin.providerModal.security.maxHeight': 'Max height',
  'pages.admin.providerModal.security.allowedFormats': 'Allowed formats',

  // ProviderCard
  'pages.admin.providerCard.config.presetModel': 'Preset model',
  'pages.admin.providerCard.config.cloneModel': 'Clone synthesis model',

  // TTSProvider
  'pages.admin.providerModal.voiceCloneModel.label': 'Voice clone synthesis model',
  'pages.admin.providerModal.voiceCloneModel.hint': 'Preset voices use the model above; cloned voice synthesis uses this VC model, which must match the target_model of the clone API',

  // Footer
  'pages.footer.copyright': '© Saibo Ai',

  // KnowledgeBaseRecallTestModal
  'pages.knowledgeBase.recall.resultFallback': 'Result',

  // CancelAccount
  'cancelAccount.warning1':
    'After account cancellation, all your personal information, device bindings, and usage data will be permanently deleted.',
  'cancelAccount.warning2': 'Cancellation is irreversible. Deleted data cannot be recovered.',
  'cancelAccount.warning3': 'Bound devices will be unbound automatically, which may affect normal device use.',
  'cancelAccount.warning4':
    'Any unused balance or benefits will be voided and cannot be refunded.',
  'cancelAccount.pleaseEnterEmail': 'Please enter your account email',
  'cancelAccount.invalidEmail': 'Please enter a valid email address',
  'cancelAccount.confirmDialogTitle': 'Confirm account cancellation request?',
  'cancelAccount.confirmDialogDesc':
    'Please read the risk notice above carefully. Confirming will generate a cancellation email.',
  'cancelAccount.accountLabel': 'Account: ',
  'cancelAccount.confirmDialogConfirm': 'Confirm request',
  'cancelAccount.confirmDialogCancel': 'Cancel',
  'cancelAccount.emailSubject': '[Account Cancellation Request]',
  'cancelAccount.emailBody': 'Hello, I would like to cancel the following account:',
  'cancelAccount.emailAccountLabel': 'Account to cancel: ',
  'cancelAccount.emailReasonLabel': 'Reason: ',
  'cancelAccount.successDialogTitle': 'Cancellation email drafted',
  'cancelAccount.successDialogDesc':
    'If your device did not open the mail client, please copy the support email below and send your cancellation request manually.',
  'cancelAccount.successDialogNote':
    'We will process your request within 7 business days after receiving the email.',
  'cancelAccount.copySuccess': 'Email copied',
  'cancelAccount.copy': 'Copy',
  'cancelAccount.gotIt': 'OK',
  'cancelAccount.headerTitle': 'Cancel Account',
  'cancelAccount.headerSubtitle':
    'Cancellation permanently deletes all data and cannot be undone. Please proceed with caution.',
  'cancelAccount.warningTitle': 'Account cancellation risks',
  'cancelAccount.emailSectionTitle': 'Confirm account',
  'cancelAccount.emailSectionDesc': 'Enter the email of the account to cancel',
  'cancelAccount.emailPlaceholder': 'Enter account email',
  'cancelAccount.reasonTitle': 'Cancellation reason',
  'cancelAccount.optional': '(Optional)',
  'cancelAccount.reasonPlaceholder': 'Tell us why you are leaving so we can improve...',
  'cancelAccount.submitButton': 'Submit cancellation request',

  // ASRProvider nostream silence
  'pages.admin.providerModal.nostreamSilence.title': 'Minor-language endpointing (advanced)',
  'pages.admin.providerModal.nostreamSilence.hint':
    'Silence endpointing ms for minor languages (e.g. Russian): higher = more complete sentences, lower = faster response. Leave blank for defaults 450/600/750. Agent asrSpeed selects the tier (1 patient / 2 normal / 3 fast).',
  'pages.admin.providerModal.nostreamSilence.fast': 'Silence endpoint · fast (ms)',
  'pages.admin.providerModal.nostreamSilence.normal': 'Silence endpoint · normal (ms)',
  'pages.admin.providerModal.nostreamSilence.slow': 'Silence endpoint · patient (ms)',

  // Microphone errors
  'helpers.media.unsupportedEnv': 'This environment cannot access the microphone',
  'helpers.media.insecureContext':
    'Microphone requires a secure context (HTTPS or localhost). The current page is not secure.',
  'helpers.media.browserUnsupported':
    'Your browser does not support microphone access. Please use the latest Microsoft Edge or Google Chrome.',

  // Register / ForgotPassword
  'pages.register.smsCode.sendFailed': 'Failed to send',
  'pages.forgotPassword.smsCode.sendFailed': 'Failed to send',

  // Welcome
  'pages.welcome.greetingLine': '{greeting}, {name}',
};
